<template>
    <div>
        <v-dialog v-model="dialog" max-width="600">
            <LabeledCard :label="$t('Фильтрация')">
                <slot>
                    <v-container fluid class="pt-5">
                        <v-form ref="filterForm">
                            <v-row dense align="center" no-gutters>
                                <v-col cols="12" sm="3" class="pl-1 pr-1">
                                    <span :class="{ 'label font-weight-bold': true, 't-15px': $vuetify.breakpoint.smAndUp }" style="position: relative; ">{{
                                        $t('Дата загрузки')
                                    }}</span>
                                </v-col>
                                <v-col cols="12" sm="9">
                                    <v-row no-gutters dense>
                                        <v-col cols="12" sm="6" class="pl-1 pr-1">
                                            <DatePicker
                                                :label="$t('Дата с')"
                                                dense
                                                outlined
                                                v-model="filterData.loadDateFrom"
                                                :class="{ 'history-date-filter': true, 'pb-2': $vuetify.breakpoint.xsOnly }"
                                                hideDetails
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6" class="pl-1 pr-1">
                                            <DatePicker
                                                :label="$t('Дата по')"
                                                dense
                                                outlined
                                                v-model="filterData.loadDateUntil"
                                                class="history-date-filter"
                                                :hideDetails="false"
                                                :rules="[checkLoadDate]"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row dense align="center" no-gutters>
                                <v-col cols="12" sm="3" class="pl-1 pr-1">
                                    <span :class="{ 'label font-weight-bold': true, 't-15px': $vuetify.breakpoint.smAndUp }" style="position: relative;">{{
                                        $t('Дата отработки')
                                    }}</span>
                                </v-col>
                                <v-col cols="12" sm="9">
                                    <v-row no-gutters dense>
                                        <v-col cols="12" sm="6" class="pl-1 pr-1">
                                            <DatePicker
                                                :label="$t('Дата с')"
                                                dense
                                                outlined
                                                :class="{ 'history-date-filter': true, 'pb-2': $vuetify.breakpoint.xsOnly }"
                                                hideDetails
                                                v-model="filterData.proccecedDateFrom"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6" class="pl-1 pr-1">
                                            <DatePicker
                                                :label="$t('Дата по')"
                                                class="history-date-filter"
                                                dense
                                                outlined
                                                :hideDetails="false"
                                                :rules="[checkStatusDate]"
                                                v-model="filterData.proccecedDateUntil"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row dense align="center" class="mb-5" no-gutters>
                                <v-col cols="12" sm="3" class="pl-1 pr-1">
                                    <span class="label font-weight-bold">{{ $t('Пользователь') }}</span>
                                </v-col>
                                <v-col cols="12" sm="9" class="pl-1 pr-1">
                                    <v-autocomplete
                                        :items="usersList"
                                        item-text="user_data.name"
                                        item-value="record_id"
                                        v-model="filterData.selectedUsers"
                                        outlined
                                        dense
                                        multiple
                                        hide-details
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row dense align="center" class="mb-5" no-gutters>
                                <v-col cols="12" sm="3" class="pl-1 pr-1">
                                    <span class="label font-weight-bold">{{ $t('Статус') }}</span>
                                </v-col>
                                <v-col cols="12" sm="9" class="pl-1 pr-1">
                                    <v-autocomplete
                                        :items="statusListSorted"
                                        item-text="ref_storage_data.name"
                                        item-value="record_id"
                                        outlined
                                        dense
                                        v-model="filterData.selectedStatus"
                                        multiple
                                        hide-details
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row dense align="center" class="mb-5" no-gutters>
                                <v-col cols="12" sm="3" class="pl-1 pr-1">
                                    <span class="label font-weight-bold">{{ $t('ID ПУТЭ') }}</span>
                                </v-col>
                                <v-col cols="12" sm="9" class="pl-1 pr-1">
                                    <v-text-field
                                        v-model="filterData.meterID"
                                        maxlength="9"
                                        dense
                                        :persistent-hint="true"
                                        :hint="this.$t('Введите полное значение')"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense align="center" class="mb-5" no-gutters>
                                <v-col cols="12" sm="3" class="pl-1 pr-1">
                                    <span class="label font-weight-bold">{{ $t('Номер ПУТЭ') }}</span>
                                </v-col>
                                <v-col cols="12" sm="9" class="pl-1 pr-1">
                                    <v-text-field
                                        dense
                                        outlined
                                        v-model="filterData.meterNumber"
                                        :persistent-hint="true"
                                        :hint="this.$t('Введите полное или частичное значение')"
                                    />
                                </v-col>
                            </v-row>
                        </v-form>

                        <v-row dense>
                            <v-col cols="12" sm="6"></v-col>
                            <v-col cols="12" sm="3" class="pl-2 pr-2">
                                <v-btn @click="handleCancel" outlined :color="$vuetify.theme.themes.dark.primary" class="w100 rounded-btn">{{
                                    $t('Отмена')
                                }}</v-btn>
                            </v-col>
                            <v-col cols="12" sm="3" class="pl-2 pr-2">
                                <v-btn class="w100 rounded-btn" @click="filterItems(filterData)" dark :color="$vuetify.theme.themes.dark.primary">{{
                                    $t('Применить')
                                }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </slot>
            </LabeledCard>
        </v-dialog>
        <v-btn color="info" class="mr-1" icon :title="$t('Обновить таблицу')" @click="getUploadsList">
            <v-icon>mdi-table-refresh</v-icon>
        </v-btn>
        <v-btn :title="$t('Фильтр')" icon :color="$vuetify.theme.themes.dark.primary" class="mr-1" @click="dialog = true">
            <v-icon>mdi-filter</v-icon>
        </v-btn>
        <v-btn :title="$t('Очистить фильтр')" icon color="red" :disabled="clearDisabled" @click="clearFilter">
            <v-icon>mdi-filter-remove</v-icon>
        </v-btn>
    </div>
</template>

<script>
import TableFilter from '@/components/ui/TableFilter';
import DatePicker from '@/components/ui/DatePicker';
import LabeledCard from '@/components/ui/LabeledCard';
import Cleave from '@/components/ui/Cleave';
import { getFilterArray, getFilterArrayWithDates } from '@/utils/filter.util';
import { isObjectEmpty, cloneObject } from '@/utils/';
import translate from '@/utils/translate.util';
import { MAX_AVAILABLE_INTEGER } from '@/config/consts';

import moment from 'moment';
import { mapState, mapActions } from 'vuex';
export default {
    props: ['showCheckboxes'],
    components: { DatePicker, LabeledCard },
    data: () => ({
        dialog: false,
        filterData: {
            loadDateFrom: null,
            proccecedDateFrom: null
        }
    }),
    watch: {
        previewDataFilter(val) {
            this.filterData = cloneObject(val);
        },
        dialog() {
            this.filterData = cloneObject(this.previewDataFilter);
        }
    },
    mounted() {},
    methods: {
        ...mapActions('uploads', ['getUploadsList']),
        filterItems(items) {
            if (!this.$refs.filterForm.validate()) return;
            const obj = {
                load_date: [items.loadDateFrom, items.loadDateUntil],
                status_date: [items.proccecedDateFrom, items.proccecedDateUntil],
                user_rid: items.selectedUsers,
                status_rid: items.selectedStatus,
                preview_meters_id: items.meterID ? Number(items.meterID.match(/\d+/g).join('')) : null,
                preview_meters_number: items.meterNumber
            };
            const processedArrayWithFilters = getFilterArray(obj);
            if (!processedArrayWithFilters && processedArrayWithFilters.length) {
                return;
            }
            let arrayFilter = {
                where: [...processedArrayWithFilters]
            };
            this.$emit('filter', arrayFilter);
            this.previewDataFilter = items;
            this.dialog = false;
        },
        clearFilter() {
            this.filterData = {};
            this.previewDataFilter = {};
            this.$emit('filter', {});
            this.$forceUpdate();
        },
        handleCancel() {
            this.dialog = false;
            this.filterData = cloneObject(this.previewDataFilter);
        }
    },
    computed: {
        ...mapState('uploads', ['servorgUsers', 'statusList']),
        statusListTranslated() {
            return translate(this.statusList, 'full', this.$i18n.locale);
        },
        checkLoadDate(val) {
            if (this.filterData.loadDateFrom && this.filterData.loadDateUntil) {
                return moment(this.filterData.loadDateFrom).isAfter(this.filterData.loadDateUntil) ? this.$t("'Дата по' не может быть раньше 'Дата с'") : true;
            } else return true;
        },
        checkStatusDate(val) {
            if (this.filterData.proccecedDateFrom && this.filterData.proccecedDateUntil) {
                return moment(this.filterData.proccecedDateFrom).isAfter(this.filterData.proccecedDateUntil)
                    ? this.$t("'Дата по' не может быть раньше 'Дата с'")
                    : true;
            } else return true;
        },
        previewDataFilter: {
            get() {
                return this.$store.state.uploads.uploadsListFilter;
            },
            set(val) {
                this.$store.commit('uploads/setUploadsListFilter', cloneObject(val));
            }
        },
        clearDisabled() {
            return isObjectEmpty(this.previewDataFilter);
        },
        usersList() {
            let users = this.servorgUsers,
                activeUsers = [],
                blockedUsers = [];

            for (let user of users) user.active ? activeUsers.push(user) : blockedUsers.push(user);

            activeUsers.sort((a, b) => {
                if (a.user_data.name && b.user_data.name) {
                    return a.user_data.name.trim().localeCompare(b.user_data.name.trim(), 'kk');
                }
            });

            blockedUsers.sort((a, b) => {
                if (a.user_data.name && b.user_data.name) {
                    return a.user_data.name.trim().localeCompare(b.user_data.name.trim(), 'kk');
                }
            });

            return [...activeUsers, ...blockedUsers];
        },
        statusListSorted() {
            let statusList = this.statusListTranslated;
            return statusList.sort((a, b) => {
                if (a.ref_storage_data.name) {
                    return a.ref_storage_data.name.trim().localeCompare(b.ref_storage_data.name.trim(), 'kk');
                }
            });
        }
    }
};
</script>

<style>
.history-date-filter .v-input .v-input__control .v-text-field__details .v-messages {
    min-height: 25px !important;
}
</style>
